import React, { memo, useEffect, useRef, useState } from "react";
import { Button, Col, Container, Row } from "react-bootstrap";
// import { BsArrowRight } from "react-icons/bs";
import { connect, useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { Field, formValueSelector, reduxForm } from "redux-form";
import RenderFieldOTPInput from "../../components/input/renderFieldOtp";
import { handleApiErrors } from "../../lib/api-errors";
import { makeGetDataAccount } from "../../lib/selector";
import { _diff2DateSecond } from "../../util";
import { required } from "../../util/validation";
import { setDataAccount, setToast } from "../client/actions";

const _regexp = /^[0-9\b]+$/;

const apiUrl = `${process.env.REACT_APP_API_URL}`;

function PageOtpVerification(props) {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [hasError, setHasError] = useState("");
  const [countdown, setCountdown] = useState(0);
  const [countResend, setCountResend] = useState(0);
  const [time, setTime] = useState(new Date());

  const { handleSubmit, dataAccount } = props;

  const inputEl1 = useRef(null);
  const inputEl2 = useRef(null);
  const inputEl3 = useRef(null);
  const inputEl4 = useRef(null);
  const inputEl5 = useRef(null);
  const inputEl6 = useRef(null);

  useEffect(() => {
    if (!dataAccount) {
      history.push("/open-account/check-info");
      return;
    }
    setLoading(false);
    setHasError("");
  }, []);

  useEffect(() => {
    if (!countdown) return;

    const intervalId = setInterval(() => {
      setCountdown(countdown - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [countdown]);

  function submit(values) {
    const { inputOtp1, inputOtp2, inputOtp3, inputOtp4, inputOtp5, inputOtp6 } =
      values;
    setLoading(true);
    setHasError("");

    const _arr = [
      inputOtp1,
      inputOtp2,
      inputOtp3,
      inputOtp4,
      inputOtp5,
      inputOtp6,
    ];

    const param = {
      mobile: dataAccount?.C_MOBILE || "back",
      otp: _arr.join(""),
    };

    checkAccountRequestApi(param);
  }

  function checkAccountRequestApi(data) {
    // history.push("/open-account/type-account");
    // return;

    const url = `${apiUrl}/verifySmsOtp`;
    const request = fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify(data),
    });

    request
      .then(handleApiErrors)
      .then((response) => response.json())
      .then((json) => {
        if (json.iRs > 0) {
          // chưa có tài khoản
          let _dataAcc = Object.assign({}, dataAccount);

          _dataAcc.S_ID = json.sData?.sid || "";
          _dataAcc.C_TYPE = "personal";

          dispatch(setDataAccount(_dataAcc));

          // history.push("/open-account/type-account");
          history.push("/open-account/personal");
        } else {
          // đã có tài khoản
          setHasError(json.sRs);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        setHasError(
          "Có lỗi trong quá trình xử lý. Quý khách vui lòng thử lại sau."
        );
        throw error;
      });
  }

  function _handleKeydown(e) {
    setHasError("");
    let { name } = e.target;
    if (e.key === "Delete" || e.key === "Backspace") {
      if (name.endsWith("2")) inputEl1 && inputEl1.current.focus();
      if (name.endsWith("3")) inputEl2 && inputEl2.current.focus();
      if (name.endsWith("4")) inputEl3 && inputEl3.current.focus();
      if (name.endsWith("5")) inputEl4 && inputEl4.current.focus();
      if (name.endsWith("6")) inputEl5 && inputEl5.current.focus();
    }
  }

  function _handleChange(e) {
    setHasError("");
    let { name, value } = e.target;
    if (_regexp.test(value)) {
      // co gia tri
      if (name.endsWith("1")) inputEl2 && inputEl2.current.focus();
      if (name.endsWith("2")) inputEl3 && inputEl3.current.focus();
      if (name.endsWith("3")) inputEl4 && inputEl4.current.focus();
      if (name.endsWith("4")) inputEl5 && inputEl5.current.focus();
      if (name.endsWith("5")) inputEl6 && inputEl6.current.focus();
    }
  }

  function resendOtp() {
    if (countdown > 0) return;
    const _diff = _diff2DateSecond(new Date(), time);
    if (countResend === 5 && _diff < 120) {
      _handleToast("Không được gửi quá 05 OTP trong vòng 2 phút!", "warning");
      return;
    }

    setTime(new Date());

    setCountResend(countResend + 1);
    setCountdown(10);

    getOtp();
  }

  function getOtp() {
    const params = {
      mobile: dataAccount?.C_MOBILE,
    };

    const url = `${apiUrl}/resendSms`;
    const request = fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=UTF-8",
      },
      body: JSON.stringify(params),
    });

    request
      .then(handleApiErrors)
      .then((response) => response.json())
      .then((json) => {})
      .catch((error) => {
        setHasError(
          "Có lỗi trong quá trình xử lý. Quý khách vui lòng thử lại sau."
        );
        // throw error;
      });
  }

  const _handleToast = (msg, type = "info") => {
    const toastMsg = {
      id: Math.random(),
      type,
      title: "Thông báo",
      msg,
    };
    dispatch(setToast(toastMsg));
  };

  return (
    <>
      <Container>
        <Row>
          <Col lg="8" className="offset-lg-2">
            <div className="content pt180">
              <h2>Xác thực OTP</h2>
              {/* <p>
                Mã OTP đã được gửi vào số điện thoại <strong>{dataAccount?.C_MOBILE}</strong>{" "}
                của Quý Khách <br />{" "}
              </p> */}
              <form
                className="form-flex email-verification-form form-otp justify-content-center"
                onSubmit={handleSubmit(submit)}
              >
                <div className="d-flex align-items-center justify-content-center form-group-otp">
                  <div className="form-group">
                    <Field
                      inputRef={inputEl1}
                      name="inputOtp1"
                      type="text"
                      className="form-control"
                      placeholder="0"
                      maxLength="1"
                      component={RenderFieldOTPInput}
                      validate={required}
                      onKeyDown={_handleKeydown}
                      onChange={_handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <Field
                      inputRef={inputEl2}
                      name="inputOtp2"
                      type="text"
                      className="form-control"
                      placeholder="0"
                      maxLength="1"
                      component={RenderFieldOTPInput}
                      validate={required}
                      onKeyDown={_handleKeydown}
                      onChange={_handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <Field
                      inputRef={inputEl3}
                      name="inputOtp3"
                      type="text"
                      className="form-control"
                      placeholder="0"
                      maxLength="1"
                      component={RenderFieldOTPInput}
                      validate={required}
                      onKeyDown={_handleKeydown}
                      onChange={_handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <Field
                      inputRef={inputEl4}
                      name="inputOtp4"
                      type="text"
                      className="form-control"
                      placeholder="0"
                      maxLength="1"
                      component={RenderFieldOTPInput}
                      validate={required}
                      onKeyDown={_handleKeydown}
                      onChange={_handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <Field
                      inputRef={inputEl5}
                      name="inputOtp5"
                      type="text"
                      className="form-control"
                      placeholder="0"
                      maxLength="1"
                      component={RenderFieldOTPInput}
                      validate={required}
                      onKeyDown={_handleKeydown}
                      onChange={_handleChange}
                    />
                  </div>
                  <div className="form-group">
                    <Field
                      inputRef={inputEl6}
                      name="inputOtp6"
                      type="text"
                      className="form-control"
                      placeholder="0"
                      maxLength="1"
                      component={RenderFieldOTPInput}
                      validate={required}
                      onKeyDown={_handleKeydown}
                      onChange={_handleChange}
                    />
                  </div>
                </div>
                <p className="resend-code">
                  Không nhận được OTP?{" "}
                  <a
                    onClick={resendOtp}
                    className={countdown > 0 ? "text-muted" : ""}
                  >
                    {countdown > 0 ? "Active sau " + countdown : "Gửi lại mã"}
                  </a>
                </p>
                <p className="text-center">
                  <Button
                    className="btn-next"
                    type="submit"
                    disabled={loading}
                    style={{ width: "415px" }}
                  >
                    TIẾP TỤC
                  </Button>
                </p>
              </form>
              {hasError && <p className="text-danger">{hasError}</p>}
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
}

PageOtpVerification = reduxForm({
  form: "accountstep2",
  enableReinitialize: true,
})(PageOtpVerification);

const selector = formValueSelector("accountstep2");

const mapStateToProps = (state) => {
  const getDataAccount = makeGetDataAccount();

  const { inputOtp1, inputOtp2, inputOtp3, inputOtp4, inputOtp5, inputOtp6 } =
    selector(
      state,
      "inputOtp1",
      "inputOtp2",
      "inputOtp3",
      "inputOtp4",
      "inputOtp5",
      "inputOtp6"
    );

  return {
    dataAccount: getDataAccount(state),
    inputOtp1,
    inputOtp2,
    inputOtp3,
    inputOtp4,
    inputOtp5,
    inputOtp6,
    initialValues: {
      inputOtp1: "",
      inputOtp2: "",
      inputOtp3: "",
      inputOtp4: "",
      inputOtp5: "",
      inputOtp6: "",
    },
  };
};

export default connect(mapStateToProps)(memo(PageOtpVerification));
